import { v4 as uuidv4 } from "uuid";
import { makeAutoObservable } from "mobx";
class ToggleStore {
  id = uuidv4();
  rootStore;
  fieldKey;
  value = false; // Single toggle value
  constructor(rootStore, fieldKey) {
    this.rootStore = rootStore;
    this.fieldKey = fieldKey;
    makeAutoObservable(this);
    this.storeToggleStoreData = this.storeToggleStoreData.bind(this);
    this.setValue = this.setValue.bind(this);
  }
  clearMe = () => {
    this.value = false; // Reset the toggle value
  };
  storeToggleStoreData(value) {
    this.value = typeof value === "boolean" ? value : false;
  }
  setValue = ({ val, trigger = false }) => {
    this.value = val;
    this.rootStore.setUnKnownFlag(this.fieldKey, this.value)
    if (trigger === true) {
      this.rootStore.generateCompanyApi({ triggerKey: trigger })
    }
  };
}
export default ToggleStore;
